<template>
  <p class="text-md font-medium tracking-wide">
    <slot />
  </p>
</template>

<script setup lang="ts"></script>
